export default {
  light: [
    [
      '#42b983',
      '#5DC395',
      '#78CDA7',
      '#93D7B9',
      '#AEE1CB',
      '#C9EBDD'
    ],
    [
      '#A96FDA',
      '#B684DF',
      '#C399E4',
      '#D0AEE9',
      '#DDC3EE',
      '#EAD8F3'
    ],
    [
      '#03C2E6',
      '#27CBEA',
      '#4BD4EE',
      '#6FDDF2',
      '#93E6F6',
      '#B7EFFA'
    ],
    [
      '#778F9B',
      '#8B9FA9',
      '#9FAFB7',
      '#B3BFC5',
      '#C7CFD3',
      '#DBDFE1'
    ]
  ],
  dark: [
    [
      '#42b983',
      '#3CA978',
      '#37986C',
      '#318760',
      '#2A7654',
      '#246548'
    ],
    [
      '#A96FDA',
      '#9A65C7',
      '#8B5BB3',
      '#7B519F',
      '#6C478B',
      '#5D3D77'
    ],
    [
      '#03C2E6',
      '#03B1D2',
      '#039FBD',
      '#038EA8',
      '#027C93',
      '#026A7E'
    ],
    [
      '#778F9B',
      '#6D828D',
      '#62767F',
      '#576971',
      '#4C5C63',
      '#414E55'
    ]
  ]
}
